import { cn } from '@/lib/utils';

import {
  FEED_ROW_TITLE_CLASS,
  FEED_STATIC_ROW_TITLE_CLASS,
  FEED_STRUCK_TITLE_CLASS,
} from './feedStyles';

import type { KeyboardEvent } from 'react';

// The strike is a 1.5 px line drawn left to right through the text's middle
const STRIKE_CLASS =
  'bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat [background-position:0_55%] [background-size:0%_1.5px] transition-[background-size,color] duration-300 ease-out motion-reduce:transition-none';

const STRIKING_CLASS = '[background-size:100%_1.5px] text-foreground-muted';

const WRAPS_CLASS =
  '!overflow-visible !whitespace-normal [overflow-wrap:anywhere]';

export const FeedRowTitle = ({
  title,
  struck,
  expanded = false,
  wraps = false,
  striking = false,
  onOpen,
  onKeyDown,
}: {
  title: string;
  struck: boolean;
  expanded?: boolean;
  // An open card's title reads in full, so it wraps where a row's title truncates
  wraps?: boolean;
  // A line draws through the title as the user checks the row off, before the row leaves
  striking?: boolean;
  onOpen?: () => void;
  onKeyDown?: (event: KeyboardEvent<HTMLElement>) => void;
}) =>
  onOpen ? (
    <button
      type="button"
      aria-expanded={expanded}
      className={cn(
        FEED_ROW_TITLE_CLASS,
        struck && FEED_STRUCK_TITLE_CLASS,
        wraps && WRAPS_CLASS,
        STRIKE_CLASS,
        striking && STRIKING_CLASS
      )}
      onClick={onOpen}
      onKeyDown={onKeyDown}
    >
      {title}
    </button>
  ) : (
    <span
      className={cn(
        FEED_STATIC_ROW_TITLE_CLASS,
        struck && FEED_STRUCK_TITLE_CLASS,
        wraps && WRAPS_CLASS
      )}
    >
      {title}
    </span>
  );
